module.exports = __webpack_public_path__ + "img/bnt.88da5ba8.svg";